module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locations-input",
    class: _vm.$style.root
  }, [(!_vm.type) ? _c('div', {
    staticClass: "buttons-container",
    class: _vm.selectedLocations.length > 0 ? "no-flex" : "flex"
  }, _vm._l((_vm.locationTypes), function(t) {
    return _c('div', {
      key: t
    }, [_c('b-button', {
      class: ("add-city btn-block set-location-type-" + t),
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          _vm.type = t
        }
      }
    }, [(_vm.selectedLocations.length > 0) ? [_vm._v(_vm._s(_vm.$t('pos.target.location.add-more', {
      type: t
    })))] : [_vm._v(_vm._s(_vm.$t('pos.target.location.add', {
      type: t
    })))]], 2)], 1)
  })) : _c('div', {
    staticClass: "form-horizontal"
  }, [_c('b-input-group', {
    staticClass: "location-autocomplete"
  }, [_c('b-button', {
    staticClass: "btn-target",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.$t('pos.target.location.add', {
    type: _vm.type
  })))]), _c('v-autocomplete', {
    directives: [{
      name: "autocomplete-extend",
      rawName: "v-autocomplete-extend"
    }],
    ref: "autocomplete",
    staticClass: "input-autocomplete",
    attrs: {
      "input-class": "form-control form-control-sm",
      "placeholder": _vm.$t("pos.target.location.placeholder", {
        type: _vm.type
      }),
      "min-len": _vm.minLength,
      "wait": _vm.debounce,
      "items": _vm.items,
      "component-item": _vm.itemTemplate,
      "auto-select-one-item": false,
      "get-label": _vm.getLocationLabel
    },
    on: {
      "update-items": _vm.onUpdateItems,
      "change": _vm.onChange
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _c('label', {
    staticClass: "control-label",
    on: {
      "click": function () { return this$1.type = null; }
    }
  }, [(_vm.loading) ? _c('icon', {
    attrs: {
      "name": "spinner",
      "spin": "spin"
    }
  }) : _c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1942586e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations-input/LocationsInput.vue
// module id = 913
// module chunks = 1